unable to read source [project]/packages/core/src/devtools/react-render-tracker/stackTrace.ts